export enum AnamneseType {
    klachten = 'klachten',
    lichamelijkOnderzoek = 'lichamelijkOnderzoek',
    redenen = 'redenen',
    risicofactoren = 'risicofactoren',
    voorgeschiedenis = 'voorgeschiedenis',
}
